// ** React Imports
import { useEffect } from 'react'

// ** Next Import
import { useRouter } from 'next/router'

// ** Hooks Import
import { useAuth } from 'src/hooks/useAuth'

// ** Util Import
import getHomeRoute from 'src/layouts/components/acl/getHomeRoute'

const GuestGuard = props => {
  const { children, fallback } = props

  const auth = useAuth()

  const router = useRouter()

  // The access token lives in memory only now, so a stale storage check can't tell
  // us whether the visitor is actually logged in - auth.isUserLoggedIn (set once the
  // boot-time silent refresh + /user call resolve) is the authoritative signal.
  // Redirects straight to the final page - going via '/' adds a hop through
  // AclGuard's spinner and a second route change.
  useEffect(() => {
    if (!router.isReady) {
      return
    }
    if (auth.isUserLoggedIn && auth.user) {
      const returnUrl = router.query.returnUrl
      router.replace(returnUrl && returnUrl !== '/' ? returnUrl : getHomeRoute(auth.user.role))
    }
  }, [router, router.route, auth.isUserLoggedIn, auth.user])

  if (auth.loading || auth.isUserLoggedIn) {
    return fallback
  }

  return <>{children}</>
}

export default GuestGuard
